import React from "react";
import { string, array, object } from "prop-types";

import Taxonomy from "../Taxonomy/Taxonomy.jsx";

const propTypes = {
  imageBackground: string,
  imageSrcSquare: string,
  title: string.isRequired,
  eyebrow: string,
  taxonomy: array,
  contentUrl: string,
  contentType: string,
  date: string,
  sizes: string,
  focusRef: object,
};

const FeaturedPromo = (props) => {
  const {
    imageBackground,
    imageSrcSquare,
    title,
    eyebrow,
    taxonomy,
    contentUrl,
    contentType,
    date,
    sizes,
    focusRef,
  } = props;

  return (
    <section className="featured-promo">
      <div className="featured-promo__container">
        <div
          className="featured-promo__media js-featured-promo-clickable"
          data-location={contentUrl}
          onClick={() => (window.location = contentUrl)}
        >
          {imageBackground && (
            <img
              className="featured-promo__background-image"
              srcSet={imageBackground}
              alt=""
              sizes="(min-width: 1170px) 1170px, 100vw"
              loading="lazy"
            />
          )}
          <img
            srcSet={imageSrcSquare}
            alt=""
            sizes={sizes || "(min-width: 1074px) 1074px, 100vw"}
          />
        </div>
        <div className="featured-promo__content">
          {eyebrow && <div className="featured-promo__eyebrow">{eyebrow}</div>}
          {(contentType || date) && (
            <div className="featured-promo__eyebrow-area">
              {contentType && (
                <div className="featured-promo__content-type">
                  {contentType}
                </div>
              )}
              {date && <div className="featured-promo__date">{date}</div>}
            </div>
          )}
          {taxonomy && (
            <div className="featured-promo__taxonomy">
              <Taxonomy values={taxonomy} />
            </div>
          )}
          <div className="featured-promo__title">
            <a href={contentUrl} ref={focusRef}>
              {title}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
FeaturedPromo.propTypes = propTypes;
export default FeaturedPromo;
